import { useCallback, useState } from "react";

import { fetchUploadFileUrl } from "@/libs/api/requests";
import { webSocketClient } from "@/libs/api/services/WebSocketService";
import { useChatContext } from "./useChatContext";
import { useToast } from "@/components/ui/use-toast";

export function useChatUpload() {
  const [loading, setLoading] = useState(false);

  const { toast } = useToast();
  const { currentConversation } = useChatContext();

  const uploadFile = useCallback(
    async (file: File, content?: string) => {
      if (!currentConversation || !currentConversation.conversationId) {
        return;
      }

      return await fetchUploadFileUrl({
        conversationId: currentConversation.conversationId,
        file,
      })
        .then((data) => {
          const socket = webSocketClient.getSocket("chats");
          if (!socket) {
            return;
          }

          socket.emit("message:send", {
            messageType: "media",
            conversationId: currentConversation.conversationId,
            fileUrl: data.url,
            fileName: data.fileId,
            content,
          });

          toast({
            title: "File uploaded successfully",
            variant: "success",
          });
        })
        .catch(() => {
          toast({
            title: "File upload failed",
            variant: "destructive",
          });
        });
    },
    [currentConversation, toast],
  );

  return {
    uploadFile,
    loading,
  };
}
